/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddChatMembersDto } from '../models/work-add-chat-members-dto';
import { WorkChatAttachmentDto } from '../models/work-chat-attachment-dto';
import { WorkChatDetailDto } from '../models/work-chat-detail-dto';
import { WorkChatEventDtoEvent } from '../models/work-chat-event-dto-event';
import { WorkChatListItemDto } from '../models/work-chat-list-item-dto';
import { WorkChatMessageDto } from '../models/work-chat-message-dto';
import { WorkChatUnreadCountDto } from '../models/work-chat-unread-count-dto';
import { WorkCreateChatMessageDto } from '../models/work-create-chat-message-dto';
import { WorkCreateDirectChatDto } from '../models/work-create-direct-chat-dto';
import { WorkCreateGroupChatDto } from '../models/work-create-group-chat-dto';
import { WorkMarkChatReadDto } from '../models/work-mark-chat-read-dto';
import { WorkMuteChatDto } from '../models/work-mute-chat-dto';
import { WorkUpdateChatDto } from '../models/work-update-chat-dto';
import { WorkUpdateChatMessageDto } from '../models/work-update-chat-message-dto';
import { WorkUploadChatAttachmentDto } from '../models/work-upload-chat-attachment-dto';

@Injectable({ providedIn: 'root' })
export class WorkChatsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `chatsV2ControllerListenToEvents()` */
  static readonly ChatsV2ControllerListenToEventsPath = '/v2/chats/events';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerListenToEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerListenToEvents$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatEventDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerListenToEventsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatEventDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerListenToEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerListenToEvents(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkChatEventDtoEvent> {
    return this.chatsV2ControllerListenToEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatEventDtoEvent>): WorkChatEventDtoEvent => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerFindAll()` */
  static readonly ChatsV2ControllerFindAllPath = '/v2/chats';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkChatListItemDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkChatListItemDto>>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkChatListItemDto>> {
    return this.chatsV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkChatListItemDto>>): Array<WorkChatListItemDto> => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerCountUnread()` */
  static readonly ChatsV2ControllerCountUnreadPath = '/v2/chats/unread-count';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerCountUnread()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerCountUnread$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatUnreadCountDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerCountUnreadPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatUnreadCountDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerCountUnread$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerCountUnread(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkChatUnreadCountDto> {
    return this.chatsV2ControllerCountUnread$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatUnreadCountDto>): WorkChatUnreadCountDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerFindOrCreateProjectChat()` */
  static readonly ChatsV2ControllerFindOrCreateProjectChatPath = '/v2/chats/project/{projectId}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerFindOrCreateProjectChat()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindOrCreateProjectChat$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerFindOrCreateProjectChatPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerFindOrCreateProjectChat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindOrCreateProjectChat(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerFindOrCreateProjectChat$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerFindOrCreateDirectChat()` */
  static readonly ChatsV2ControllerFindOrCreateDirectChatPath = '/v2/chats/direct';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerFindOrCreateDirectChat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerFindOrCreateDirectChat$Response(
    params: {
      body: WorkCreateDirectChatDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerFindOrCreateDirectChatPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerFindOrCreateDirectChat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerFindOrCreateDirectChat(
    params: {
      body: WorkCreateDirectChatDto
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerFindOrCreateDirectChat$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerCreateGroup()` */
  static readonly ChatsV2ControllerCreateGroupPath = '/v2/chats/group';

  /**
   * Required permissions: chats:create, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerCreateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerCreateGroup$Response(
    params: {
      body: WorkCreateGroupChatDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerCreateGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:create, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerCreateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerCreateGroup(
    params: {
      body: WorkCreateGroupChatDto
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerCreateGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerDeleteMessage()` */
  static readonly ChatsV2ControllerDeleteMessagePath = '/v2/chats/messages/{messageId}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerDeleteMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerDeleteMessage$Response(
    params: {
      messageId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerDeleteMessagePath, 'delete');
    if (params) {
      rb.path('messageId', params.messageId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerDeleteMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerDeleteMessage(
    params: {
      messageId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.chatsV2ControllerDeleteMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerUpdateMessage()` */
  static readonly ChatsV2ControllerUpdateMessagePath = '/v2/chats/messages/{messageId}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerUpdateMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerUpdateMessage$Response(
    params: {
      messageId: number;
      body: WorkUpdateChatMessageDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatMessageDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerUpdateMessagePath, 'patch');
    if (params) {
      rb.path('messageId', params.messageId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatMessageDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerUpdateMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerUpdateMessage(
    params: {
      messageId: number;
      body: WorkUpdateChatMessageDto
    },
    context?: HttpContext
  ): Observable<WorkChatMessageDto> {
    return this.chatsV2ControllerUpdateMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatMessageDto>): WorkChatMessageDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerFindOne()` */
  static readonly ChatsV2ControllerFindOnePath = '/v2/chats/{id}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerArchive()` */
  static readonly ChatsV2ControllerArchivePath = '/v2/chats/{id}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerArchive()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerArchive$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerArchivePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerArchive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerArchive(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.chatsV2ControllerArchive$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerUpdate()` */
  static readonly ChatsV2ControllerUpdatePath = '/v2/chats/{id}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateChatDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateChatDto
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerAddMembers()` */
  static readonly ChatsV2ControllerAddMembersPath = '/v2/chats/{id}/members';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerAddMembers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerAddMembers$Response(
    params: {
      id: number;
      body: WorkAddChatMembersDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerAddMembersPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerAddMembers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerAddMembers(
    params: {
      id: number;
      body: WorkAddChatMembersDto
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerAddMembers$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerRemoveMember()` */
  static readonly ChatsV2ControllerRemoveMemberPath = '/v2/chats/{id}/members/{userId}';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerRemoveMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerRemoveMember$Response(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerRemoveMemberPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerRemoveMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerRemoveMember(
    params: {
      id: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.chatsV2ControllerRemoveMember$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerMute()` */
  static readonly ChatsV2ControllerMutePath = '/v2/chats/{id}/mute';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerMute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerMute$Response(
    params: {
      id: number;
      body: WorkMuteChatDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatDetailDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerMutePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatDetailDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerMute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerMute(
    params: {
      id: number;
      body: WorkMuteChatDto
    },
    context?: HttpContext
  ): Observable<WorkChatDetailDto> {
    return this.chatsV2ControllerMute$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatDetailDto>): WorkChatDetailDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerMarkRead()` */
  static readonly ChatsV2ControllerMarkReadPath = '/v2/chats/{id}/read';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerMarkRead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerMarkRead$Response(
    params: {
      id: number;
      body: WorkMarkChatReadDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerMarkReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerMarkRead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerMarkRead(
    params: {
      id: number;
      body: WorkMarkChatReadDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.chatsV2ControllerMarkRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerFindMessages()` */
  static readonly ChatsV2ControllerFindMessagesPath = '/v2/chats/{id}/messages';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerFindMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindMessages$Response(
    params: {
      id: number;
      beforeId?: number;
      afterId?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkChatMessageDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerFindMessagesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('beforeId', params.beforeId, {});
      rb.query('afterId', params.afterId, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkChatMessageDto>>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerFindMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatsV2ControllerFindMessages(
    params: {
      id: number;
      beforeId?: number;
      afterId?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkChatMessageDto>> {
    return this.chatsV2ControllerFindMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkChatMessageDto>>): Array<WorkChatMessageDto> => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerCreateMessage()` */
  static readonly ChatsV2ControllerCreateMessagePath = '/v2/chats/{id}/messages';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerCreateMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerCreateMessage$Response(
    params: {
      id: number;
      body: WorkCreateChatMessageDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatMessageDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerCreateMessagePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatMessageDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerCreateMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  chatsV2ControllerCreateMessage(
    params: {
      id: number;
      body: WorkCreateChatMessageDto
    },
    context?: HttpContext
  ): Observable<WorkChatMessageDto> {
    return this.chatsV2ControllerCreateMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatMessageDto>): WorkChatMessageDto => r.body)
    );
  }

  /** Path part for operation `chatsV2ControllerUploadAttachment()` */
  static readonly ChatsV2ControllerUploadAttachmentPath = '/v2/chats/{id}/attachments';

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatsV2ControllerUploadAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  chatsV2ControllerUploadAttachment$Response(
    params: {
      id: number;
      body: WorkUploadChatAttachmentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkChatAttachmentDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkChatsV2Service.ChatsV2ControllerUploadAttachmentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkChatAttachmentDto>;
      })
    );
  }

  /**
   * Required permissions: chats:read, chats:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatsV2ControllerUploadAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  chatsV2ControllerUploadAttachment(
    params: {
      id: number;
      body: WorkUploadChatAttachmentDto
    },
    context?: HttpContext
  ): Observable<WorkChatAttachmentDto> {
    return this.chatsV2ControllerUploadAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkChatAttachmentDto>): WorkChatAttachmentDto => r.body)
    );
  }

}
